import { DataType, ParquetFormState } from './types';

const API_BASE = 'https://data.abcz-tr.com';

/**
 * Maps the UI display-name DataType to the snake_case table ID
 * that the FastAPI backend expects (matches query_builder.py).
 */
const DATA_TYPE_TO_API_ID: Record<DataType, string> = {
  'SPOT OHLCV': 'spot_ohlcv',
  'FUTURES OHLCV': 'futures_ohlcv',
  'Funding Rate': 'funding_rate',
  'Open Interest': 'open_interest',
  'Global Long/Short Ratio': 'global_ls_ratio',
  'Top Long/Short (Accounts)': 'top_ls_account',
  'Top Long/Short (Positions)': 'top_ls_position',
  'Taker Buy/Sell': 'taker_buy_sell',
  'Spot Orderbook': 'spot_depth',
  'Futures Orderbook': 'futures_depth',
};

export async function generateParquet(
  payload: ParquetFormState,
  onProgress?: (bytesReceived: number) => void,
): Promise<Blob> {
  // 网页下载已停用 — 改用 API + API key 下载, 见 Docs / FRIEND_API。
  void payload;
  void onProgress;
  void API_BASE;
  void DATA_TYPE_TO_API_ID;
  throw new Error(
    '网页下载已停用。请改用 API 下载: 在 Docs 页复制 curl/Python 示例, 带上你的 API key。',
  );
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);

  setTimeout(() => {
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 200);
  }, 0);
}
